import { ReactNode, lazy } from 'react'

const DependentRequestPage = lazy(
  () => import('@/presentation/pages/dependent-request/dependent-request-page')
)

const DependentRequestCatalogPage = lazy(
  () => import('@/presentation/pages/dependent-request/dependent-request-catalog-page')
)

const DependentContentPage = lazy(() =>
  import('@/presentation/pages/content/content-details/content-page-with-context').then(module => ({
    default: module.DependentContentPage
  }))
)

export const makeDependentRequestPage = (): ReactNode => {
  return <DependentRequestPage />
}

export const makeDependentRequestCatalogPage = (): ReactNode => {
  return <DependentRequestCatalogPage />
}

export const makeDependentContentPage = (): ReactNode => {
  return <DependentContentPage />
}
